export default "__VITE_ASSET__x73vRR1W__"